import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import {
    Box, Button,
    Checkbox, DialogActions,
    DialogContent,
    FormControlLabel,
    FormGroup,
    TextField,
} from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import loadingYardList from 'recoil/selectors/loadingYardList';


type YardSelectDialogProps = {
    saved: number[],
} & ModalActionProps<number[]>

const YardSelectDialog = ({saved, onFinish}: YardSelectDialogProps) => {
    const yards = useRecoilValue(loadingYardList);
    const {t} = useTranslation();
    const [filter, setFilter] = useState('');
    const [selected, setSelected] = useState(saved.reduce((obj, key) => {
        obj[key] = true;
        return obj;
    }, {} as { [k: number]: boolean }));

    let filtered = filter ? yards.filter(y => y.name.toLowerCase().includes(filter)) : [...yards];

    filtered.sort((a, b) => a.portId - b.portId);

    const change = (e: React.ChangeEvent<HTMLInputElement>) =>
        setSelected(old => ({...old, [e.target.name]: e.target.checked}));

    return (
        <Box>
            <DialogContent>
                <TextField
                    id="yard"
                    label={t('filter')}
                    fullWidth
                    value={filter}
                    onChange={e => setFilter(e.target.value.toLowerCase())}
                />

                <FormGroup>
                    {filtered.map(yard => (
                        <FormControlLabel
                            key={yard.id}
                            control={<Checkbox
                                name={yard.id.toString()}
                                checked={selected[yard.id] || false}
                                onChange={change}
                            />}
                            label={`${yard.port.name} ${yard.name}`}
                        />
                    ))}
                </FormGroup>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={() => onFinish(Object.keys(selected).map(Number).filter(key => selected[key]))}
                >
                    {t('save')}
                </Button>
            </DialogActions>
        </Box>
    );
};

export default YardSelectDialog;
